import TrashOutlineIcon from '@eduzz/houston-icons/TrashOutline';
import UploadIcon from '@eduzz/houston-icons/Upload';
import Alert from '@eduzz/houston-ui/Alert';
import { IconButton, List, ListItem, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Spin from 'components/Spin';
import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import uploadService from 'v2/services/upload';

import { FormContent } from '../../EditProduct/components/FormContent';
import { useStyles } from './styles';

import type { FileWithPath } from 'react-dropzone';

interface IProps {
  onUpload: (upload_id: number) => void;
  onRemove: () => void;
}

export const PrivateLabelRights = ({ onUpload, onRemove }: IProps) => {
  const classes = useStyles();
  const [file, setFile] = useState<FileWithPath>();
  const [uploading, setUploading] = useState<boolean>(false);

  const onDrop = (files: FileWithPath[]) => {
    const f = [...files].shift();
    onUploadFile(f);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
  });

  const onUploadFile = useCallback(
    (file) => {
      setUploading(true);
      uploadService
        .uploadFile(file, 'private_label_rights')
        .then((response: { data: { upload_id: number } }) => {
          setFile(file);
          onUpload(response.data.upload_id);
          setUploading(false);
        })
        .catch(() => {
          toast.error('Falha ao subir arquivo, tente novamente');
          setFile(null);
          setUploading(false);
        });
    },
    [onUpload]
  );

  const handleRemove = () => {
    setFile(null);
    onRemove();
  };

  return (
    <FormContent title='Direitos Privados de Etiqueta' loading={false}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Alert type='warning' closeIcon={false}>
            O conteúdo deve ser de sua autoria, certifique-se de que a autoria está visível no arquivo e compatível com seus dados na plataforma. Caso
            o conteúdo não seja de sua autoria deve ser anexado no campo ao lado o PLR (Private Label Rights Products - Direitos Privados de Etiqueta)
            para que seu conteúdo seja aprovado.
          </Alert>
        </Grid>
        <Grid item xs={12} md={6}>
          {!uploading && file && (
            <>
              <h4>Arquivo</h4>
              <List>
                <ListItem key={file.lastModified} className={classes.item}>
                  <ListItemText>{file.name}</ListItemText>
                  <ListItemSecondaryAction>
                    <IconButton onClick={handleRemove}>
                      <TrashOutlineIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </>
          )}
          {!file && (
            <div id='drag-and-drop-plr' {...getRootProps({ className: classes.dropzone })}>
              {uploading && <Spin message={'Por favor aguarde, estamos fazendo upload do arquivo.'} />}
              {!uploading && (
                <>
                  <input {...getInputProps()} />
                  <UploadIcon />
                  <p>Selecione ou arraste seu arquivo de PLR (Direitos Privados de Etiqueta)</p>
                </>
              )}
            </div>
          )}
        </Grid>
      </Grid>
    </FormContent>
  );
};
